import dayjs from 'dayjs';
import i18next from 'i18next';
import { VoucherClearingLogFilterType } from "../graphql/types/VoucherClearingLogType";
import { VoucherClearingFilterType } from "../graphql/types/VoucherClearingType";
import { hasResource } from "../../../../utils/resourceAuth";
import { ResourceCode } from "../../../../constants/resourceCodes";

export const voucherClearingFilterBase: VoucherClearingFilterType = {
    businessId: undefined,
    otherBusinessId: undefined,
    settlementItemCode: undefined,
    settlementClientId: undefined,
    userType: undefined,
    voucherClearStatus: undefined,
    businessTime: null,
    settlementTime: null,
};

/** 初始筛选值：Client Type 默认为当前角色下的第一个选项 */
export const getVoucherClearingFilterInitialValue = (): VoucherClearingFilterType => {
    const options = getVoucherClearingUserTypeOptions();
    const firstValue = options[0]?.value;
    const startOfMonth = dayjs().startOf('month').format('YYYY-MM-DD');
    const currentDate = dayjs().format('YYYY-MM-DD');

    return { 
        ...voucherClearingFilterBase, 
        userType: firstValue,
        settlementTime: [startOfMonth, currentDate]
    };
};

export const validateVoucherClearingFilters = (f: VoucherClearingFilterType): string | null => {
    const hasBusinessId = Boolean(f.businessId?.trim());
    const hasSettlementTime = Boolean(f.settlementTime?.[0] || f.settlementTime?.[1]);

    // Conditional requirement: if no businessId, settlementTime is required
    if (!hasBusinessId && !hasSettlementTime) {
        return i18next.t('需要选择 Settlement Time 或输入 Tracking');
    }

    return null;
};

export const VoucherClearingFilterInitialValue: VoucherClearingFilterType = voucherClearingFilterBase;

/** 按资源码返回用户类型选项：有哪个权限加哪个选项，都没有返回空 */
export const getVoucherClearingUserTypeOptions = () => {
    const hasDsp = hasResource([ResourceCode.settlement.SETTLEMENT_COST_CLEARING_VOUCHER]);
    const hasIncome = hasResource([ResourceCode.settlement.SETTLEMENT_REVENUE_CLEARING_VOUCHER]);
    const orderOption = { label: i18next.t('voucherClearing.userType.order'), value: 'order' };
    const dspOption = { label: i18next.t('voucherClearing.userType.dsp'), value: 'dsp' };
    if (hasDsp && hasIncome) return [orderOption, dspOption];
    if (hasIncome) return [orderOption];
    if (hasDsp) return [dspOption];
    return [];
};

export const voucherClearingStatusOptions = [
    { label: 'available', value: '1' },
    { label: 'unavailable', value: '0' },
];

export const VoucherClearingLogFilterInitialValue: VoucherClearingLogFilterType = {
    businessId: undefined,
    reRunTaskId: undefined,
};